import { Button, Card, Modal } from "react-bootstrap";
import { ProjectFirstStage } from "../../models/project-first-stage";
import * as ProjectFirstStageApi from "../../network/project-first-stages-api";
import styles from "../../styles/ChangeStageDialog.module.css";

interface FirstStageDialogProps {
    stage: ProjectFirstStage,
    onDismiss: () => void,
}

const FirstStageDialog = ({stage, onDismiss}: FirstStageDialogProps) => {
    const downloadFile = () => {
        ProjectFirstStageApi.fetchProjectFirstStageFile({projectId: stage.projectId});
    }
    
    return(
        <Modal show onHide={onDismiss}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Этап 1
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className={`mb-3 ${styles.descriptionField}`}>
                    <Card.Header>
                        Описание
                    </Card.Header>
                    <Card.Body>
                        {stage.text}
                    </Card.Body>
                </Card>
                <Button onClick={downloadFile} className={styles.downloadFileButton}>
                    Скачать закреплённый документ
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default FirstStageDialog;